import { connect } from 'react-redux'
import WashLabelComponent from '../components/WashLabelComponent.jsx';
import {
  changeWashLabelValue,
  generateWashLabel,
  findAllOrderIds,
  cleanWashLabelAlert
} from '../actions';

const mapStateToProps = (state) => ({
  washLabel: state.getIn(['washLabelReducer', 'washLabel']),
  washLabelValidation: state.getIn(['washLabelReducer', 'washLabelValidation']),
  alertStyle: state.getIn(['washLabelReducer', 'alertStyle']),
  alertMessage: state.getIn(['washLabelReducer', 'alertMessage']),
  allOrderIds: state.getIn(['fittingReducer', 'allOrderIds'])
})

const mapDispatchToProps = (dispatch) => ({
  generateWashLabel: (washLabel) => {
    dispatch(generateWashLabel(washLabel))
  },
  setValue: (id, value) => {
    dispatch(changeWashLabelValue({
      id: id,
      value: value
    }))
  },
  findAllOrderIds: () => {
    dispatch(findAllOrderIds());
  },
  cleanAlert: () => {
    dispatch(cleanWashLabelAlert());
  }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  washLabel: stateProps.washLabel,
  washLabelValidation: stateProps.washLabelValidation,
  alertStyle: stateProps.alertStyle,
  alertMessage: stateProps.alertMessage,
  allOrderIds: stateProps.allOrderIds,
  generateWashLabel: () => dispatchProps.generateWashLabel(stateProps.washLabel),
  setValue: dispatchProps.setValue,
  findAllOrderIds: dispatchProps.findAllOrderIds,
  cleanAlert: dispatchProps.cleanAlert
})

const WashLabelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WashLabelComponent)

export default WashLabelContainer;


// WEBPACK FOOTER //
// ./src/containers/WashLabelContainer.jsx